unit View.Servicos_Nacional.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls, UUtils,
  UHelperServer, UWeb.Enum;

type
  TFViewServicos_NacionalEdit = class(TForm)
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbcTribNac: TLabel;
    edcTribNac: TDBEdit;
    lbdescricao: TLabel;
    eddescricao: TDBEdit;
    lbexcluido: TLabel;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientServicos_NacionalGet: TXDataWebClient;
    Servicos_NacionalDataset: TXDataWebDataSet;
    Servicos_NacionalDatasetid: TIntegerField;
    Servicos_NacionalDatasetcTribNac: TStringField;
    Servicos_NacionalDatasetdescricao: TStringField;
    Servicos_NacionalDatasetexcluido: TBooleanField;
    Servicos_NacionalDatasetinclusao: TDateTimeField;
    Servicos_NacionalDatasetalteracao: TDateTimeField;
    Servicos_NacionalDatasetexclusao: TDateTimeField;
    cbExcluido: TDBCheckBox;
    procedure btCancelClick(Sender: TObject);
    [async]
    procedure btSaveClick(Sender: TObject); async;
    procedure XDataClientServicos_NacionalGetLoad(Response: TXDataClientResponse);
    procedure Servicos_NacionalDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormShow(Sender: TObject);
    procedure edcTribNacKeyPress(Sender: TObject; var Key: Char);
    procedure edcTribNacClick(Sender: TObject);
    procedure eddescricaoClick(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewServicos_NacionalEdit: TFViewServicos_NacionalEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewServicos_NacionalEdit }

procedure TFViewServicos_NacionalEdit.btSaveClick(Sender: TObject);
begin
  if THelperServer.VerificarCampoVazio(edcTribNac) then
  begin
    TUtils.SetErroClass('lbcTribNac', 'Preencha o cTribNac!');
    Exit;
  end
  else if (Length(trim(edcTribNac.Text)) <> 6) then
  begin
    TUtils.SetErroClass('lbcTribNac', 'Campo cTribNac deve ter 6 caracteres!');
    Exit;
  end;

  if THelperServer.VerificarCampoVazio(eddescricao) then
  begin
    TUtils.SetErroClass('lbdescricao', 'Preencha a descrição!');
    Exit;
  end;

  if Await(TUtils.ChamarMensagemDialog(TTipoDialogo.CONFIRMACAO, THelperServer.GetMensagemPadraoSalvar(FInserting))) then
  begin
    if Servicos_NacionalDataset.State in dsEditModes then
    begin
      Servicos_NacionalDataset.Post;
      Servicos_NacionalDataset.ApplyUpdates;
    end
    else
      FShowListProc;
  end;
end;

class function TFViewServicos_NacionalEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewServicos_NacionalEdit.edcTribNacClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbcTribNac');
end;

procedure TFViewServicos_NacionalEdit.edcTribNacKeyPress(Sender: TObject;
  var Key: Char);
begin
  if not(key in ['0'..'9']) Then
    key := #0;
end;

procedure TFViewServicos_NacionalEdit.eddescricaoClick(Sender: TObject);
begin
  TUtils.RemoverErroClass('lbdescricao');
end;

procedure TFViewServicos_NacionalEdit.InsertEntity;
begin
  Servicos_NacionalDataset.Close;
  Servicos_NacionalDataset.SetJsonData('{}');
  Servicos_NacionalDataset.Open;
  Servicos_NacionalDataset.Insert;
end;

class function TFViewServicos_NacionalEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewServicos_NacionalEdit(AForm).FInserting := AInserting;
    TFViewServicos_NacionalEdit(AForm).FId := AId;
    TFViewServicos_NacionalEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewServicos_NacionalEdit(AForm).InsertEntity
    else
      TFViewServicos_NacionalEdit(AForm).LoadEntity;
  end;

begin
  Application.CreateForm(TFViewServicos_NacionalEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewServicos_NacionalEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Servicos_NacionalDataset.Connection.Model.DefaultSchema.FindEntityType(
      Servicos_NacionalDataset.EntitySetName
    )
  );
  XDataClientServicos_NacionalGet.Get(Servicos_NacionalDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewServicos_NacionalEdit.XDataClientServicos_NacionalGetLoad(Response: TXDataClientResponse);
begin
  Servicos_NacionalDataset.Close;
  Servicos_NacionalDataset.SetJsonData(Response.Result);
  Servicos_NacionalDataset.Open;
  
  Servicos_NacionalDataset.Edit;  
end;

procedure TFViewServicos_NacionalEdit.Servicos_NacionalDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      TUtils.ChamarMensagemDialog(TTipoDialogo.ERROR, ResolveInfo.Error);
      Servicos_NacionalDataset.Edit;
      Exit;
    end;
  end;

  TUtils.ChamarMensagemDialog(TTipoDialogo.SUCESSO, THelperServer.GetMensagemPadraoSalvarSucesso(FInserting));
  FShowListProc;
end;

procedure TFViewServicos_NacionalEdit.WebFormShow(Sender: TObject);
begin
  if FInserting then
    THelperServer.RemoverDiv('campos-controle')
  else
  begin
    if not TUtils.PossuiPermissao(Servicos_NacionalDataset.EntitySetName.ToLower, TTipoPermissao.ALTERAR) then
    begin
      btSave.Enabled := False;
      edcTribNac.Enabled := False;
      eddescricao.Enabled := False;
      cbExcluido.Enabled := False;
    end;
  end;
end;

procedure TFViewServicos_NacionalEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewServicos_NacionalEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbid := TLabel.Create('view.servicos_nacional.form.lbid');
  lbcTribNac := TLabel.Create('view.servicos_nacional.form.lbcTribNac');
  lbdescricao := TLabel.Create('view.servicos_nacional.form.lbdescricao');
  lbexcluido := TLabel.Create('view.servicos_nacional.form.lbexcluido');
  lbinclusao := TLabel.Create('view.servicos_nacional.form.lbinclusao');
  lbalteracao := TLabel.Create('view.servicos_nacional.form.lbalteracao');
  lbexclusao := TLabel.Create('view.servicos_nacional.form.lbexclusao');
  btCancel := TButton.Create('view.servicos_nacional.form.btBack');
  btSave := TButton.Create('view.servicos_nacional.form.btSave');
  edid := TDBEdit.Create('view.servicos_nacional.form.edid');
  edcTribNac := TDBEdit.Create('view.servicos_nacional.form.edcTribNac');
  eddescricao := TDBEdit.Create('view.servicos_nacional.form.eddescricao');
  edinclusao := TDBEdit.Create('view.servicos_nacional.form.edinclusao');
  edalteracao := TDBEdit.Create('view.servicos_nacional.form.edalteracao');
  edexclusao := TDBEdit.Create('view.servicos_nacional.form.edexclusao');
  cbExcluido := TDBCheckBox.Create('view.servicos_nacional.form.cbexcluido');
  DataSource := TDataSource.Create(Self);
  Servicos_NacionalDataset := TXDataWebDataSet.Create(Self);
  Servicos_NacionalDatasetid := TIntegerField.Create(Self);
  Servicos_NacionalDatasetcTribNac := TStringField.Create(Self);
  Servicos_NacionalDatasetdescricao := TStringField.Create(Self);
  Servicos_NacionalDatasetexcluido := TBooleanField.Create(Self);
  Servicos_NacionalDatasetinclusao := TDateTimeField.Create(Self);
  Servicos_NacionalDatasetalteracao := TDateTimeField.Create(Self);
  Servicos_NacionalDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientServicos_NacionalGet := TXDataWebClient.Create(Self);

  lbid.BeforeLoadDFMValues;
  lbcTribNac.BeforeLoadDFMValues;
  lbdescricao.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  edcTribNac.BeforeLoadDFMValues;
  eddescricao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  cbExcluido.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Servicos_NacionalDataset.BeforeLoadDFMValues;
  Servicos_NacionalDatasetid.BeforeLoadDFMValues;
  Servicos_NacionalDatasetcTribNac.BeforeLoadDFMValues;
  Servicos_NacionalDatasetdescricao.BeforeLoadDFMValues;
  Servicos_NacionalDatasetexcluido.BeforeLoadDFMValues;
  Servicos_NacionalDatasetinclusao.BeforeLoadDFMValues;
  Servicos_NacionalDatasetalteracao.BeforeLoadDFMValues;
  Servicos_NacionalDatasetexclusao.BeforeLoadDFMValues;
  XDataClientServicos_NacionalGet.BeforeLoadDFMValues;
  try
    Name := 'FViewServicos_NacionalEdit';
    Width := 593;
    Height := 454;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 23;
    lbid.Height := 13;
    lbid.Caption := 'C'#243'd:';
    lbid.HeightPercent := 100.000000000000000000;
    lbid.WidthPercent := 100.000000000000000000;
    lbcTribNac.SetParentComponent(Self);
    lbcTribNac.Name := 'lbcTribNac';
    lbcTribNac.Left := 24;
    lbcTribNac.Top := 219;
    lbcTribNac.Width := 45;
    lbcTribNac.Height := 13;
    lbcTribNac.Caption := 'cTribNac:';
    lbcTribNac.HeightPercent := 100.000000000000000000;
    lbcTribNac.WidthPercent := 100.000000000000000000;
    lbdescricao.SetParentComponent(Self);
    lbdescricao.Name := 'lbdescricao';
    lbdescricao.Left := 24;
    lbdescricao.Top := 246;
    lbdescricao.Width := 50;
    lbdescricao.Height := 13;
    lbdescricao.Caption := 'Descri'#231#227'o:';
    lbdescricao.HeightPercent := 100.000000000000000000;
    lbdescricao.WidthPercent := 100.000000000000000000;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 273;
    lbexcluido.Width := 44;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'Exclu'#237'do?';
    lbexcluido.HeightPercent := 100.000000000000000000;
    lbexcluido.WidthPercent := 100.000000000000000000;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 300;
    lbinclusao.Width := 44;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'Inclus'#227'o:';
    lbinclusao.HeightPercent := 100.000000000000000000;
    lbinclusao.WidthPercent := 100.000000000000000000;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 327;
    lbalteracao.Width := 50;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'Altera'#231#227'o:';
    lbalteracao.HeightPercent := 100.000000000000000000;
    lbalteracao.WidthPercent := 100.000000000000000000;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 354;
    lbexclusao.Width := 46;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'Exclus'#227'o:';
    lbexclusao.HeightPercent := 100.000000000000000000;
    lbexclusao.WidthPercent := 100.000000000000000000;
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 394;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancelar';
    btCancel.HeightPercent := 100.000000000000000000;
    btCancel.TabOrder := 1;
    btCancel.WidthPercent := 100.000000000000000000;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 394;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Salvar';
    btSave.HeightPercent := 100.000000000000000000;
    btSave.TabOrder := 4;
    btSave.WidthPercent := 100.000000000000000000;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := False;
    edid.HeightPercent := 100.000000000000000000;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.WidthPercent := 100.000000000000000000;
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    edcTribNac.SetParentComponent(Self);
    edcTribNac.Name := 'edcTribNac';
    edcTribNac.Left := 221;
    edcTribNac.Top := 216;
    edcTribNac.Width := 200;
    edcTribNac.Height := 21;
    edcTribNac.HeightPercent := 100.000000000000000000;
    edcTribNac.MaxLength := 6;
    edcTribNac.TabOrder := 7;
    edcTribNac.Text := 'edcTribNac';
    edcTribNac.WidthPercent := 100.000000000000000000;
    SetEvent(edcTribNac, Self, 'OnClick', 'edcTribNacClick');
    SetEvent(edcTribNac, Self, 'OnKeyPress', 'edcTribNacKeyPress');
    edcTribNac.DataField := 'cTribNac';
    edcTribNac.DataSource := DataSource;
    eddescricao.SetParentComponent(Self);
    eddescricao.Name := 'eddescricao';
    eddescricao.Left := 221;
    eddescricao.Top := 243;
    eddescricao.Width := 200;
    eddescricao.Height := 21;
    eddescricao.CharCase := wecUpperCase;
    eddescricao.HeightPercent := 100.000000000000000000;
    eddescricao.TabOrder := 8;
    eddescricao.Text := 'eddescricao';
    eddescricao.WidthPercent := 100.000000000000000000;
    SetEvent(eddescricao, Self, 'OnClick', 'eddescricaoClick');
    eddescricao.DataField := 'descricao';
    eddescricao.DataSource := DataSource;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 297;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := False;
    edinclusao.HeightPercent := 100.000000000000000000;
    edinclusao.TabOrder := 10;
    edinclusao.Text := 'edinclusao';
    edinclusao.WidthPercent := 100.000000000000000000;
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 324;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := False;
    edalteracao.HeightPercent := 100.000000000000000000;
    edalteracao.TabOrder := 11;
    edalteracao.Text := 'edalteracao';
    edalteracao.WidthPercent := 100.000000000000000000;
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 351;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := False;
    edexclusao.HeightPercent := 100.000000000000000000;
    edexclusao.TabOrder := 12;
    edexclusao.Text := 'edexclusao';
    edexclusao.WidthPercent := 100.000000000000000000;
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    cbExcluido.SetParentComponent(Self);
    cbExcluido.Name := 'cbExcluido';
    cbExcluido.Left := 221;
    cbExcluido.Top := 270;
    cbExcluido.Width := 200;
    cbExcluido.Height := 22;
    cbExcluido.Caption := 'cbExcluido';
    cbExcluido.ChildOrder := 13;
    cbExcluido.HeightPercent := 100.000000000000000000;
    cbExcluido.WidthPercent := 100.000000000000000000;
    cbExcluido.DataField := 'excluido';
    cbExcluido.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Servicos_NacionalDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Servicos_NacionalDataset.SetParentComponent(Self);
    Servicos_NacionalDataset.Name := 'Servicos_NacionalDataset';
    Servicos_NacionalDataset.AfterApplyUpdates := Servicos_NacionalDatasetAfterApplyUpdates;
    Servicos_NacionalDataset.EntitySetName := 'Servicos_Nacional';
    Servicos_NacionalDataset.Connection := DMConnection.ApiConnection;
    Servicos_NacionalDataset.Left := 176;
    Servicos_NacionalDataset.Top := 8;
    Servicos_NacionalDatasetid.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetid.Name := 'Servicos_NacionalDatasetid';
    Servicos_NacionalDatasetid.FieldName := 'id';
    Servicos_NacionalDatasetcTribNac.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetcTribNac.Name := 'Servicos_NacionalDatasetcTribNac';
    Servicos_NacionalDatasetcTribNac.FieldName := 'cTribNac';
    Servicos_NacionalDatasetcTribNac.Required := True;
    Servicos_NacionalDatasetcTribNac.Size := 255;
    Servicos_NacionalDatasetdescricao.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetdescricao.Name := 'Servicos_NacionalDatasetdescricao';
    Servicos_NacionalDatasetdescricao.FieldName := 'descricao';
    Servicos_NacionalDatasetdescricao.Required := True;
    Servicos_NacionalDatasetdescricao.Size := 255;
    Servicos_NacionalDatasetexcluido.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetexcluido.Name := 'Servicos_NacionalDatasetexcluido';
    Servicos_NacionalDatasetexcluido.FieldName := 'excluido';
    Servicos_NacionalDatasetinclusao.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetinclusao.Name := 'Servicos_NacionalDatasetinclusao';
    Servicos_NacionalDatasetinclusao.FieldName := 'inclusao';
    Servicos_NacionalDatasetinclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Servicos_NacionalDatasetalteracao.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetalteracao.Name := 'Servicos_NacionalDatasetalteracao';
    Servicos_NacionalDatasetalteracao.FieldName := 'alteracao';
    Servicos_NacionalDatasetalteracao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    Servicos_NacionalDatasetexclusao.SetParentComponent(Servicos_NacionalDataset);
    Servicos_NacionalDatasetexclusao.Name := 'Servicos_NacionalDatasetexclusao';
    Servicos_NacionalDatasetexclusao.FieldName := 'exclusao';
    Servicos_NacionalDatasetexclusao.DisplayFormat := 'dd/mm/yyyy hh:nn:ss';
    XDataClientServicos_NacionalGet.SetParentComponent(Self);
    XDataClientServicos_NacionalGet.Name := 'XDataClientServicos_NacionalGet';
    XDataClientServicos_NacionalGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientServicos_NacionalGet, Self, 'OnLoad', 'XDataClientServicos_NacionalGetLoad');
    XDataClientServicos_NacionalGet.Left := 64;
    XDataClientServicos_NacionalGet.Top := 8;
  finally
    lbid.AfterLoadDFMValues;
    lbcTribNac.AfterLoadDFMValues;
    lbdescricao.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    edcTribNac.AfterLoadDFMValues;
    eddescricao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    cbExcluido.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Servicos_NacionalDataset.AfterLoadDFMValues;
    Servicos_NacionalDatasetid.AfterLoadDFMValues;
    Servicos_NacionalDatasetcTribNac.AfterLoadDFMValues;
    Servicos_NacionalDatasetdescricao.AfterLoadDFMValues;
    Servicos_NacionalDatasetexcluido.AfterLoadDFMValues;
    Servicos_NacionalDatasetinclusao.AfterLoadDFMValues;
    Servicos_NacionalDatasetalteracao.AfterLoadDFMValues;
    Servicos_NacionalDatasetexclusao.AfterLoadDFMValues;
    XDataClientServicos_NacionalGet.AfterLoadDFMValues;
  end;
end;

end.
